<template>
  <div
    class="sprite-icon"
    :style="{'background-position':position, backgroundColor:backgroundColor}"
  ></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "icon",
  props: {
    img: Number,
    active: Boolean,
    flash: Boolean
  },
  computed: {
    backgroundColor() {
      if (this.side == "adversary" && !this.active) {
        return "#960000";
      } else if (this.side == "advocate" && !this.active) {
        return "#070664";
      } else if (!this.side && this.active) {
        return "#000000";
      } else {
        return "#f1ece6";
      }
    },
    position() {
      let x = 0;
      let y = 0;

      if (!this.side && this.active) {
        x = "-42px";
      } else if (this.side && !this.active) {
        x = "-42px";
      }

      return x + " " + -42 * this.img + "px";
    },
    ...mapGetters(["side"])
  }
};
</script>

<style>
.sprite-icon {
  display: inline-block;
  width: 42px;
  height: 42px;
  background-image: url("../assets/images/icon-sprite.png");
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}
</style>
